import loggingService from '../util/loggingService'

var serviceName = 'projectTypeService'
var path = '/Lookup/ProjectType/'
var isDebug = false

function listLookup (http) {
    loggingService.log(isDebug, serviceName, 'listLookup')

    return http.get(path + 'ListLookup')
}

export default {
    listLookup: listLookup
}



// WEBPACK FOOTER //
// ./src/services/lookup/projectTypeService.js